import { render, staticRenderFns } from "./xmxy_index.vue?vue&type=template&id=7b35032f&scoped=true&"
import script from "./xmxy_index.vue?vue&type=script&lang=js&"
export * from "./xmxy_index.vue?vue&type=script&lang=js&"
import style0 from "./xmxy_index.vue?vue&type=style&index=0&id=7b35032f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35032f",
  null
  
)

export default component.exports